import parser from 'html-react-parser'

const moneyFormatter = new Intl.NumberFormat('kr-KO', {
    style: 'currency',
    currency: 'KRW',
})

const utils = {
    getToken: () => localStorage.getItem('login-token'),

    getUserId: () => Number(localStorage.getItem('user-id')),

    isEmailValid: (email) => {
        return email
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
    },

    formatMoney: (money: number | null) => {
        if (money == null) return ''

        return moneyFormatter.format(money)
    },

    splitArray: (originalArray: any[], count: number) => {
        if (originalArray == null) return [[]]

        const splitList: any[][] = []

        for (let i = 0; i < originalArray.length; i += count) {
            splitList.push(originalArray.slice(i, i + count))
        }

        return splitList
    },

    insertCommas: (str) => {
        var reversed = str.toString().split('').reverse().join('')
        var result = reversed
            .replace(/(\d{3})/g, '$1,')
            .split('')
            .reverse()
            .join('')

        return result.startsWith(',') ? result.substring(1) : result
    },

    insertSpace: (str, atEvery = 4) => {
        return str.replace(new RegExp(`(\\d{${atEvery}})`, 'g'), '$1 ')
    },

    isHoursPassed: (key: string, hours: number): boolean => {
        const storedTimestamp = localStorage.getItem(key)

        if (storedTimestamp) {
            const storedTime = new Date(storedTimestamp)
            const currentTime = new Date()
            const timeDiff = currentTime.getTime() - storedTime.getTime()
            const hoursPassed = timeDiff / (1000 * 60 * 60)
            return hoursPassed >= hours
        }

        return false
    },

    getNumbersFromLocalStorage: (key: string): [number | null, number | null] => {
        const storedValue = localStorage.getItem(key)
        if (storedValue) {
            const [firstValue, secondValue] = storedValue.split(',')
            return [parseFloat(firstValue), parseFloat(secondValue)]
        }
        return [null, null]
    },

    htmlParser: parser,

    isNumber(value: string): boolean {
        return !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
    },

    formatMinutes(minutes: number | string): string {
        const min = typeof minutes === 'string' ? Number(minutes) : minutes
        if (!Number.isFinite(min) || isNaN(min)) return '-'
        if (min >= 60) {
            const h = Math.floor(min / 60)
            const m = min % 60
            return m === 0 ? `${utils.insertCommas(h)}시간` : `${utils.insertCommas(h)}시간 ${m}분`
        }
        return `${min}분`
    },

    formatMinutesCompact(minutes: number | string): string {
        const min = typeof minutes === 'string' ? Number(minutes) : minutes
        if (!Number.isFinite(min) || isNaN(min)) return '-'
        if (min >= 60) {
            const h = min / 60
            return `${parseFloat(h.toFixed(1))}시간`
        }
        return `${min}분`
    },

    formatTime(time: string | null): string {
        if (time == null) {
            return '-'
        }

        const date = time.split('T')[0];
        const [year, month, day] = date.split('-');
        return `${year.slice(2, 4)}년 ${month}월 ${day}일`
    }
}

export default utils